import Bulletin from "../../../../pages/platforms/cashier/bulletin";
import {
  Cashier,
  Contract,
  Deals,
  Menus,
  Services,
  Membership,
  Outsources,
  Utilities,
  Wellness,
  Referrals,
  Remittances,
  Hotlines,
  Suppliers,
  Payables,
  Receivables,
  Vouchers,
  Payments,
  // SOA,
  // Onboarding,
} from "../../../../pages/platforms/cashier";

const cashier = [
  {
    name: "Bulletin",
    icon: "bullhorn",
    path: "/bulletin",
    title: "News and Updates",
    component: Bulletin,
  },
  {
    name: "Cash Register",
    path: "/cash/register",
    icon: "cash-register",
    title: "Cash Register Functions",
    children: [
      {
        name: "P O S",
        path: "/pos",
        icon: "shopping-cart",
        title: "Point of Sales",
        component: Cashier,
      },
      {
        name: "Deals",
        path: "/deals",
        icon: "tags",
        title: "Service Deals of the Day",
        component: Deals,
      },
      {
        name: "Remittances",
        path: "/remittances",
        icon: "exchange-alt",
        title: "Daily Remittance Ledger",
        component: Remittances,
      },
      {
        name: "Onboarding",
        path: "/onboarding",
        icon: "sign-in-alt",
        title: "Pre-Registered Patients & HMO Approvals",
        // component: Onboarding,
      },
    ],
  },
  {
    name: "Accrued",
    path: "/accrued",
    icon: "file-invoice",
    title: "Liabilities and Obligations",
    children: [
      {
        name: "Accounts Payable (A/P)",
        path: "/payables",
        icon: "file-invoice-dollar",
        title: "Outstanding Payments to Suppliers & Utilities",
        component: Payables,
      },
      {
        name: "Payments",
        path: "/payments",
        icon: "money-check-alt",
        title: "List of Payments Made by cashier",
        component: Payments,
      },
      {
        name: "Accounts Receivable (A/R)",
        path: "/receivables",
        icon: "wallet",
        title: "Billing for Corporate & HMO Invoices",
        component: Receivables,
      },
      {
        name: "Vouchers",
        path: "/vouchers",
        icon: "receipt",
        title: "Monthly Vouchers for Referrals (Cashier only)",
        component: Vouchers,
      },
    ],
  },
  {
    name: "Sources",
    path: "/sources",
    icon: "building",
    title: "Outsources & Insources",
    children: [
      {
        name: "Outsources",
        path: "/outsources",
        icon: "people-carry",
        title: "External Service Providers (Sendouts)",
        component: Outsources,
      },
      {
        name: "Affiliated Patient Programs",
        path: "/insources",
        icon: "hand-holding-heart",
        title: "Patient Sources with Discounts or Privileges",
        children: [
          {
            name: "H M O Wellness",
            path: "/wellness",
            icon: "briefcase-medical",
            title: "Partner Companies with HMO Coverage",
            component: Wellness,
          },
          {
            name: "Membership Privileges",
            path: "/membership",
            icon: "id-card-alt",
            title: "Members with Discounted Rates",
            component: Membership,
          },
          {
            name: "Contracted Rates",
            path: "/contract",
            icon: "file-signature",
            title: "Special Pricing Agreements",
            component: Contract,
          },
          {
            name: "Referral Sources",
            path: "/referrals",
            icon: "paper-plane",
            title: "Clinics or Doctors Who Referred Patients",
            component: Referrals,
          },
        ],
      },
      {
        name: "Suppliers",
        path: "/suppliers",
        icon: "boxes",
        title: "Suppliers for Goods & Services",
        component: Suppliers,
      },
      {
        name: "Utilities",
        path: "/utilities",
        icon: "plug",
        title: "Utilities & Support Services",
        component: Utilities,
      },
      {
        name: "Hotlines",
        path: "/hotlines",
        icon: "phone-alt",
        title: "Emergency & Support Hotlines",
        component: Hotlines,
      },
    ],
  },
  {
    name: "Services Catalog",
    path: "/catalogs",
    icon: "clipboard-list",
    title: "Service Listings",
    children: [
      {
        name: "Menus",
        path: "/menus",
        icon: "utensils",
        title: "List of Menus",
        component: Menus,
      },
      {
        name: "Services",
        path: "/services",
        icon: "concierge-bell",
        title: "List of Services",
        component: Services,
      },
    ],
  },
];

export default cashier;
